export default __webpack_public_path__ + "static/media/category-accessories.c89ddada.png";